<template>
  <span
    class="tag"
    :class="statusClass"
  >
    {{ status == 'Revoked' ? 'Rejected' : status }} 
    <!-- Temporary fix of adding rejected -->
  </span>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  computed: {
    statusClass() {
      switch (this.status) {
      case "Passed":
        return "is-success";
      case "Failed":
      case "Revoked":
        return "is-danger";
      case "Expired":
        return "is-warning";
      case "Pending":
        return "is-info";
      case "Incomplete":
        return "is-light-red";
      case "Open":
        return "is-warning";
      case "Resolved":
        return "is-success";
      case "Closed":
        return "is-dark";
      }

      return "";
    },
  },
};
</script>
